import {
  ChangeDetectionStrategy,
  Component,
  ElementRef,
  inject,
  Input,
} from '@angular/core';

export type BadgeType = 'error' | 'success' | 'warning';

@Component({
  selector: 'wo-badge',
  templateUrl: './badge.component.html',
  styleUrls: [ './badge.component.scss' ],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
})
export class BadgeComponent {
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  @Input({ required: true }) public set type(type: BadgeType) {
    this.elementRef.nativeElement.style.color = this.colorFor(type);
  }

  private colorFor(type: BadgeType): string {
    switch (type) {
      case 'success':
        return '#479a42';
      default:
        return '#0b3f9f';
    }
  }
}
